/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Activate_Confirm_TextInputs */



/**
* | output |
* | --- |
* | "This will end your trial immediately and start your paid subscription. Are you sure?" |
*
* @param {Activate_Confirm_TextInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const activate_confirm_text = /** @type {((inputs?: Activate_Confirm_TextInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Activate_Confirm_TextInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Votre période d'essai sera immédiatement interrompue et votre abonnement payant commencera. Êtes-vous sûr(e) ?")
	if (locale === "de") return /** @type {LocalizedString} */ ("Damit endet Ihre Testphase sofort und Ihr kostenpflichtiges Abonnement beginnt. Sind Sie sicher?")
	if (locale === "it") return /** @type {LocalizedString} */ ("Questo terminerà immediatamente la prova e inizierà l'abbonamento a pagamento. Sei sicuro?")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Это немедленно завершит ваш пробный период и активирует платную подписку. Вы уверены?")
	if (locale === "es") return /** @type {LocalizedString} */ ("Esto finalizará tu prueba inmediatamente y comenzará tu suscripción de pago. ¿Estás seguro?")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("这将立即结束您的试用期并开始您的付费订阅。您确定吗？")
	if (locale === "ja") return /** @type {LocalizedString} */ ("トライアルは直ちに終了し、有料サブスクリプションが開始されます。よろしいですか？")
	if (locale === "hi") return /** @type {LocalizedString} */ ("इससे आपका ट्रायल पीरियड तुरंत समाप्त हो जाएगा और आपकी पेड सब्सक्रिप्शन शुरू हो जाएगी। क्या आप निश्चित हैं?")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Isso encerrará seu período de teste imediatamente e iniciará sua assinatura paga. Tem certeza?")
	return /** @type {LocalizedString} */ ("This will end your trial immediately and start your paid subscription. Are you sure?")
});